export default {"src":"/_next/static/media/ic-contract.94485579.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};